var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body column"},[_c('header',{staticClass:"paper"},[_c('n-link',{attrs:{"to":_vm.$store.state.session.signed_in ? '/home': '/'}},[_c('Logo')],1)],1),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"page"},[_c('nuxt')],1)]),_vm._v(" "),_c('Housekeeping')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }